var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"config-code-link",class:_vm.variant === 'nav' ? 'is-nav' : 'is-inline',attrs:{"type":"button"},on:{"click":_vm.open}},[_vm._v(" Have a configuration code? ")])}
var staticRenderFns = []

export { render, staticRenderFns }